
angular.module('tf.directives')

    .directive('pieChart', ['C3Service','$state','Legend',function(C3Service, $state, Legend) {
    return {
        restrict: 'E',
        template: '<div class="tf-pie"></div>',
        replace: true,
        scope:{
            data:"=",
            options :"=?"
        },
        link : function(scope,element,attr){

            var data = scope.data? C3Service.pie(scope.data.values) : [];
            var chart = c3.generate({
                bindto : element[0],
                data: {
                    // iris data from R
                    columns: data,
                    type : 'pie',
                    onclick: function (d, i) {
                        if(scope.data && scope.data.meta && scope.data.meta[d.id]){
                            $state.go('app.statistics.dashboard', {encoded : scope.data.meta[d.id].url});
                        }
                    }
                },

                pie: {
                    label: {
                        format: function (value, ratio, id) {
                            return value;
                        }
                    }
                },

                color: {
                    pattern: scope.options.colors
                },
                legend: {
                    show: false
                },
                onrendered: function () {
                    Legend.create(element, this.api, scope.data, scope.options.clickKey);
                }


            });

            scope.$watch('data', function(data){
                if(data) {
                    chart.load({
                        unload: true,
                        columns: C3Service.pie(data.values),
                        done : function(){
                            chart.show();
                            var categories = C3Service.getSortedCategories(data.values);
                            chart.hide(categories.slice(5,categories.length));
                        }
                    });

                }
            });

        }
    };

}]);